export default __webpack_public_path__ + "static/media/NeptuneDb.04bcb43a.svg";